import { Link } from "react-router";
import DefaultInstructorImage from "../assets/images/ab-img.png";
import DefaultCourseImage from "../assets/images/student-course-bg-image.png";
import { useSelector } from "react-redux";

const CourseCard = ({
  courseId,
  courseImage = DefaultCourseImage,
  instructorImage = DefaultInstructorImage,
  instructorName,
  category,
  title,
  teacherId = null,
  role,
  course
}) => {
    const globalState = useSelector((state) => state.globalState);
  
  return (
    <div className="StudentCourseCard-main-container">
      <div
        className="studentDashboar-Suggested-Courses-folder"
        id="studentCourseCard-folder"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div className="studentDashboar-Suggested-Courses-image" style={{ width: "100%" }}>
          <img src={courseImage} alt={title} style={{height: "160px", display: "block" , objectfit:"contain"}} />
        </div>

        <div className="studentDashboar-Suggested-Courses-profile-folder" style={{ width: "100%" }}>
          <div className="studentDashboar-Suggested-Courses-profile">
            <div className="studentDashboar-profile-image">
              <img src={instructorImage} alt={instructorName} />
            </div>
            <div className="studentDashboar-Suggested-Courses-profile-title">
              <h2 className="tudentDashboar-profile-card-title">
                {instructorName}
              </h2>
              <p>Teacher</p>
            </div>
          </div>
        </div>

        <p className="studentDashboar-profile-course-name">{category}</p>

        <div className="studentDashboard-course-name-rating">
          <h2 className="studentDashboar-profile-course-title">{title}</h2>

          {globalState.enabled_modules?.includes('marketplace') && (
            <div className="studentDashboar-Suggested-Courses-profile-rate !flex-row">
                <a> <i className="fa-solid fa-star"></i> </a>
                <p className="rate">{course?.average_course_rating || "0"}</p>
                <p className="number">({parseInt(course?.rating_count || 0)})</p>
            </div>
          )}
        </div>

        <div className="studentDashboar-profile-btn-folder" style={{ width: "100%", marginTop: "auto" }}>
          <Link to={`/course/course-id/${courseId}`} state={{ teacher_id: teacherId, role:role }} style={{ textDecoration: "none", width: "100%" }}>
            <button type="button" className="course-btn" style={{padding:"12px",border:"none",borderRadius:"10px",width:"100%",backgroundColor:"#0068FF",color:"#fff",fontSize:"14px",fontWeight:"500",cursor:"pointer"}}>
              View Course
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CourseCard;
